module.exports = __webpack_public_path__ + "images/323e81bf.jpg";